import React from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import WidgetCard from "./WidgetCard";
import { IMsVsRpiTrendsData, PricingCharts } from "@ts/common-types";
import { COLORS } from "@ts/constants";
import { Col, Row } from "antd";

const MsVsRpiTrends: React.FC<IMsVsRpiTrendsData> = ({
    widgetData,
    title,
    additionalTitleComponent,
    currencySymbol
}) => {
    const getChartConfig = () => {
        return {
            chart: {
                type: "line",
                responsive: true,
            },
            title: {
                text: "",
            },
            xAxis: {
                categories: widgetData.categories,
                title: {
                    text: "Date",
                },
            },
            yAxis: [
                {
                    title: {
                        text: `${widgetData.series[0]?.name} (${currencySymbol})` || "RPI",
                    },
                    opposite: false,
                },
                {
                    title: {
                        text: "Market Share (%)",
                    },
                    labels: {
                        format: "{value}%",
                    },
                    opposite: true,
                },
            ],
            series: widgetData.series.map((s, index) => ({
                name: s.name,
                data: s.data,
                type: "line",
                yAxis: index,
            })),
            responsive: {
                rules: [
                    {
                        condition: {
                            maxWidth: 500,
                        },
                        chartOptions: {
                            legend: {
                                align: "center",
                                verticalAlign: "bottom",
                                layout: "horizontal",
                            },
                        },
                    },
                ],
            },
            credits: {
                enabled: false,
            },
            colors: COLORS,
            tooltip: {
                shared: true,
                valueSuffix: "",
            },
            legend: {
                layout: "horizontal",
                align: "center",
                verticalAlign: "bottom",
            },
        };
    };

    return (
        <WidgetCard className="my-4">
            <Row className="fs-5 mb-5 w-100" justify="space-between">
                <Col span={16}>
                    <h5>{title || "MS Vs RPI"}</h5>
                </Col>
                {additionalTitleComponent && (
                    <Col span={8}>{additionalTitleComponent(PricingCharts.MS_RPI_PPU, PricingCharts.MS_RPI)}</Col>
                )}
            </Row>
            <HighchartsReact
                highcharts={Highcharts}
                options={getChartConfig()}
            />
        </WidgetCard>
    );
};

export default MsVsRpiTrends;